import type { MetricsResponse } from "@shared/types";
import { TileCard } from "./TileCard";
import { formatInteger } from "@/lib/format";

interface ConversationsTileProps {
  conversations: MetricsResponse["conversations"];
}

export function ConversationsTile({ conversations }: ConversationsTileProps) {
  const { liveNow, closedToday, escalatedToday } = conversations;
  const accent = escalatedToday > 0 ? "amber" : null;

  return (
    <TileCard
      label="Active conversations"
      accent={accent}
      testId="tile-conversations"
    >
      <div className="tile-number" data-testid="conversations-live">
        {formatInteger(liveNow)} <span
          style={{ fontSize: 14, color: "var(--text-muted)", fontWeight: 400 }}
        >
          live
        </span>
      </div>
      <div className="tile-subline">
        <span data-testid="conversations-closed">
          {formatInteger(closedToday)} closed today
        </span>
        {" · "}
        <span
          data-testid="conversations-escalated"
          style={{
            color: escalatedToday > 0 ? "var(--amber)" : undefined,
          }}
        >
          {formatInteger(escalatedToday)} escalated
        </span>
      </div>
    </TileCard>
  );
}
